export default {
  'hy': {
    'order': 'Պատվիրել',
    'order_now': 'Պատվիրել հիմա',
    'gallery': 'Պատկերասրահ',
    'amd': 'դրամ',
    'special_offer': 'հատուկ առաջարկ',
    'contact': 'Կապ',
    'home_page': 'Գլխավոր էջ',
    'online_shop': 'Օնլայն խանութ',
    'pies': 'Խմորեղեններ',
    'cakes': 'Տորթեր',
    'other': 'Այլ',
    'all': 'Բոլորը',
    'image': 'Նկար',
    'name': 'Անուն',
    'quantity': 'Քանակ',
    'remove': 'Ջնջել',
    'total': 'Ընդհանուր',
    'price': 'Գին',
    'total_price': 'Ընդհանուր գին',
    'city': 'Քաղաք',
    'address': 'Հասցե',
    'phone_number': 'Հեռախոսահամար',
    'additional_description': 'Լրացուցիչ տեղեկություն',
    'deliver_as_soon_as_possible': 'Առաքել հնարավորինս շուտ',
    'date': 'Օր',
    'time': 'ժամ',
    'order_conditions': 'Պատվերի պայմաններ',
    'total_with_delivery': 'Ընդհանուր առաքմամբ',
    'fill_all_required_fields': 'Լրացրեք բոլոր պահանջվող դաշտերը',
    'correct_fill_all_required_fields': 'Խնդրում ենք լրացնել բոլոր պահանջվող դաշտերը ճիշտ',
    'order_success': 'Պատվերը ավելացվել է',
    'order_success_accepted': 'Ձեր պատվերն ընդունվել է համակարգի կողմից: Պատվերի մասին հետագա տեղեկատվությունները կստանաք հեռախոսազանգի միջոցով:',
    'tanks_for_choose': 'Շնորհակալություն մեզ ընտրելու համար',
    'order_went_wrong': 'Ինչ որ բան այնպես չգնաց. Պատվերը չի ընդունվել: Խնդրում ենք կրկին փորձել կամ փորձեք պատվիրել այլ եղանակով',
    'payment_method': 'Վճարման եղանակ',
    'payment_success': 'Վճարումը հաջողությամբ կատարված է',
    'cash': 'Կանխիկ',
    'temp_not_accepting_orders__new_year_reason': "Գերծանրաբեռնվածության պատճառով ժամանակավորապես դադարեցվել է կայքով պատվերների ընդունումը։ Պատվերների ընդունումը կվերականգնվի Նոր տարվա տոներից հետո։\n" +
      "Հայցում ենք ձեր ներողամտությունը առաջացած անհարմարության համար",
    'attention': 'Ուշադրություն'
  },
  'ru': {
    'order': 'Заказать',
    'order_now': 'Заказать сейчас',
    'gallery': 'Галерея',
    'amd': 'драм',
    'special_offer': 'специальное предложение',
    'contact': 'Контакт',
    'home_page': 'Домашняя страница',
    'online_shop': 'Интернет магазин',
    'pies': 'Пирожные',
    'cakes': 'Торты',
    'other': 'Другой',
    'all': 'Все',
    'image': 'Изображение',
    'name': 'Название',
    'quantity': 'Количество',
    'remove': 'Удалить',
    'total': 'Общий',
    'price': 'Цена',
    'total_price': 'Итоговая цена',
    'city': 'Город',
    'address': 'Адрес',
    'phone_number': 'Телефонный номер',
    'additional_description': 'Дополнительное сведения',
    'deliver_as_soon_as_possible': 'Доставить как можно скорее',
    'date': 'Дата',
    'time': 'Время',
    'order_conditions': 'Условия заказа',
    'total_with_delivery': 'Итого с доставкой',
    'fill_all_required_fields': 'Пожалуйста, заполните все обязательные поля',
    'correct_fill_all_required_fields': 'Пожалуйста, заполните все обязательные поля правильно',
    'order_success': 'Заказ добавлен',
    'order_success_accepted': 'Ваш заказ принят системой. Дальнейшую информацию о заказе вы получите по телефону.',
    'tanks_for_choose': 'Спасибо, что выбрали нас',
    'order_went_wrong': 'Что-то пошло не так. Заказ не принят. Пожалуйста, попробуйте еще раз или попробуйте заказать другим способом',
    'payment_method': 'Способ оплаты',
    'payment_success': 'Платеж успешно выполнен',
    'cash': 'Наличные',
    'temp_not_accepting_orders__new_year_reason': 'В связи с перегрузкой временно приостановлен прием заказов через сайт. Прием заказов будет восстановлен после новогодних праздников.\n' +
      'Просим прощения за доставленные неудобства.',
    'attention': 'Внимание'
  },
  'en': {
    'order': 'Order',
    'order_now': 'Order now',
    'gallery': 'Gallery',
    'amd': 'amd',
    'special_offer': 'special offer',
    'contact': 'Contact',
    'home_page': 'Home page',
    'online_shop': 'Online shop',
    'pies': 'Pies',
    'cakes': 'Cakes',
    'other': 'Other',
    'all': 'All',
    'image': 'Image',
    'name': 'Name',
    'quantity': 'Quantity',
    'remove': 'Remove',
    'total': 'Total',
    'price': 'Price',
    'total_price': 'Total price',
    'city': 'City',
    'address': 'Address',
    'phone_number': 'Phone number',
    'additional_description': 'Additional information',
    'deliver_as_soon_as_possible': 'Deliver as soon us possible',
    'date': 'Date',
    'time': 'Time',
    'order_conditions': 'Order conditions',
    'total_with_delivery': 'Total with delivery',
    'fill_all_required_fields': 'Please fill all required fields',
    'correct_fill_all_required_fields': 'Please fill all required fields correct',
    'order_success': 'Order submitted',
    'order_success_accepted': 'Your order has been accepted by system. You will receive further information about the order by phone call.',
    'tanks_for_choose': 'Thanks for choose us',
    'order_went_wrong': 'Something went wrong. Order has not been accepted. Please try again or try to order another way',
    'payment_method': 'Payment method',
    'payment_success': 'Payment completed successfully',
    'cash': 'Cash',
    'temp_not_accepting_orders__new_year_reason': 'Due to overload, the acceptance of orders through the website has been temporarily suspended. Order acceptance will resume after the New Year holidays.\n' +
      'We kindly ask for your understanding and apologize for the inconvenience.',
    'attention': 'Attention'
  }
}



// WEBPACK FOOTER //
// ./src/plugins/i18n.js